const LEGACY_UTC_ACTION_TYPES = new Set([
  'file_process',
  'timeevent',
  'timeevent_ingest',
  'widget',
]);

export const normalizeTimestampString = (value, { assumeUtcForNaive = false } = {}) => {
  if (typeof value !== 'string') {
    return value;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return trimmed;
  }

  let normalized = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T');
  normalized = normalized.replace(/(\.\d{3})\d+/, '$1');
  const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized);
  if (hasTimezone || !assumeUtcForNaive) {
    return normalized;
  }
  return `${normalized}Z`;
};

export const actionLogUsesLegacyUtc = (log) => LEGACY_UTC_ACTION_TYPES.has(
  String(log?.action_type || '').trim().toLowerCase(),
);

export const normalizeActionLogTimestamp = (value, log) => normalizeTimestampString(value, {
  assumeUtcForNaive: actionLogUsesLegacyUtc(log),
});
